/* ============================================================================
   RENKEISEN · assets/rk-medicion.js                              04-09-2026
   Señales propias para Microsoft Clarity.

   POR QUE EXISTE ESTE ARCHIVO
   Clarity lleva instalado desde el 1-sep y graba sesiones, pero no recibe ni
   una señal de la tienda: solo sabe que alguien estuvo. Por eso hoy no se
   puede responder la pregunta que importa en contra entrega, que no es
   "cuanta gente entro" sino "cuantos abrieron el formulario, cuantos lo
   llenaron, y cuantos apretaron el boton". Sin eventos propios no hay funnel
   que construir: la documentacion es explicita en que un funnel se arma
   arrastrando smart events, y los eventos de API cuentan como tales.

   LA REGLA DE ORO DE ESTE ARCHIVO: NO TOCA NADA.
   Solo escucha. No agrega listeners que cancelen eventos, no modifica el DOM,
   no depende de que ninguna app este presente. Si Clarity no cargo, cada
   llamada se descarta en silencio y la tienda funciona igual. Una medicion
   que puede romper una venta no vale la venta que mide.

   NADA DE DATOS PERSONALES.
   Se marca el producto, el modo de pago, cuantas lineas trae el carro y la
   region. Nunca el nombre, el telefono, el correo ni la direccion. Clarity
   enmascara los campos de formulario por su cuenta, y esto no lo deshace.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- puente con Clarity, tolerante a que no este ----------
     El fragmento de Clarity define window.clarity como una cola apenas se
     inserta, asi que normalmente ya existe. Pero la etiqueta la pone la APP
     de Shopify y puede llegar despues que este archivo, sobre todo en movil
     con red lenta. Se reintenta durante 10 segundos y despues se abandona,
     porque una cola infinita en memoria es peor que un evento perdido. */
  var cola = [];
  var listo = false;
  var intentos = 0;

  function hay() {
    return typeof window.clarity === 'function';
  }

  function soltar() {
    if (!hay()) { return false; }
    listo = true;
    for (var i = 0; i < cola.length; i++) {
      try { window.clarity.apply(null, cola[i]); } catch (e) {}
    }
    cola = [];
    return true;
  }

  function cl() {
    var args = Array.prototype.slice.call(arguments);
    if (listo || hay()) {
      if (!listo) { listo = true; }
      try { window.clarity.apply(null, args); } catch (e) {}
      return;
    }
    if (cola.length < 40) { cola.push(args); }
  }

  if (!soltar()) {
    var reloj = setInterval(function () {
      intentos++;
      if (soltar() || intentos > 40) { clearInterval(reloj); }
    }, 250);
  }

  /* ---------- cada evento se emite UNA vez por pagina ----------
     Clarity registra cada llamada por separado. Un evento repetido no aporta
     y ademas ensucia el funnel: si "formulario abierto" se emitiera tres
     veces, el paso mostraria mas sesiones de las que hubo. */
  var yaSalio = {};
  function evento(nombre) {
    if (yaSalio[nombre]) { return; }
    yaSalio[nombre] = true;
    cl('event', nombre);
  }
  function marca(clave, valor) {
    if (valor === null || valor === undefined || valor === '') { return; }
    cl('set', clave, String(valor).slice(0, 60));
  }
  /* upgrade pide a Clarity que priorice esta grabacion cuando haya muestreo.
     Se usa SOLO en los dos momentos que de verdad quiero poder mirar uno por
     uno: el formulario abierto y el formulario completo. Marcarlo todo
     equivale a no marcar nada. */
  function subir(razon) {
    cl('upgrade', razon);
  }

  var cuerpo = document.body;
  if (!cuerpo) { return; }
  var esFicha = cuerpo.className.indexOf('rk-tpl-producto') >= 0;
  var esCarro = cuerpo.className.indexOf('rk-tpl-carro') >= 0;

  /* ================= 1. QUE ESTA MIRANDO ================= */
  if (esFicha) {
    var handle = '';
    try {
      var m = location.pathname.match(/\/products\/([^/?#]+)/);
      if (m) { handle = decodeURIComponent(m[1]); }
    } catch (e) {}
    marca('rk_producto', handle);
    evento('rk_ficha_vista');
  }
  if (esCarro) { evento('rk_carro_visto'); }

  /* ================= 2. PULSA UN BOTON DE PAGO =================
     Es la intencion de compra real, y hoy no queda registrada en ningun
     sitio: el AddToCart que ve Meta se dispara solo al cargar la pagina, asi
     que no distingue a quien quiso comprar de quien solo paso. */
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest
      ? ev.target.closest('[data-rk-cta], [data-rk-ir]')
      : null;
    if (!t) { return; }
    var modo = t.getAttribute('data-rk-cta') === 'prepago' ? 'prepago' : 'contra_entrega';
    marca('rk_modo', modo);
    evento('rk_pago_pulsado');
    evento(modo === 'prepago' ? 'rk_pago_prepago' : 'rk_pago_contra_entrega');
  }, true);

  /* ================= 3. EL EMBUDO DE LA FICHA =================
     AGREGADO EL 30-09-2026, y es el motivo de esta reescritura.

     Lo que habia aqui medía el formulario de contra entrega de Releasit y
     la oferta del cepillo. La tienda pasó a solo pago en linea el 12-09 y
     Releasit se apagó en el tema, asi que quince de los dieciocho eventos
     dejaron de dispararse. Quedaban vivos tres: ficha vista, carro visto y
     pago pulsado.

     El problema de fondo: entre "entró a la ficha" y "apretó comprar" no se
     medía NADA. Con 335 sesiones, 1 venta y CERO checkouts abandonados en
     catorce dias, el abandono ocurre dentro de la ficha, y era justo el
     tramo a oscuras.

     Estos eventos cierran ese hueco. Todos son de intencion, ninguno guarda
     dato personal. */

  if (esFicha) {

    /* --- 3.1 ELIGIO UN PACK ---
       Separa al que comparó opciones del que solo pasó. Si mucha gente elige
       pack y casi nadie compra, el problema es el precio; si nadie llega a
       elegir, el problema es lo que hay antes. */
    document.addEventListener('change', function (ev) {
      var r = ev.target;
      if (!r || !r.classList || !r.classList.contains('rk-pack__radio')) { return; }
      evento('rk_pack_elegido');
      marca('rk_pack', r.value);
    }, true);

    /* --- 3.2 HASTA DONDE LEYO ---
       La ficha mide 17,6 pantallas en un telefono. Sin esto no hay forma de
       saber si el que se fue vio el precio o ni siquiera llegó. Se emite un
       evento por umbral y una sola vez, para que el funnel de Clarity no
       cuente de mas. */
    var umbrales = [25, 50, 75, 100];
    function mirarScroll() {
      var alto = document.documentElement.scrollHeight - window.innerHeight;
      if (alto <= 0) { return; }
      var pct = Math.round((window.scrollY / alto) * 100);
      for (var i = 0; i < umbrales.length; i++) {
        if (pct >= umbrales[i]) { evento('rk_scroll_' + umbrales[i]); }
      }
    }
    var ultimoScroll = 0;
    window.addEventListener('scroll', function () {
      var ahora = Date.now();
      if (ahora - ultimoScroll < 250) { return; }
      ultimoScroll = ahora;
      mirarScroll();
    }, { passive: true });

    /* --- 3.3 ABRIO UNA PREGUNTA ---
       Abrir un acordeon es duda concreta. Saber CUAL se abre dice que
       información falta en la ficha: si todos abren "Cómo se toma", esa
       respuesta deberia estar a la vista y no escondida. */
    document.addEventListener('click', function (ev) {
      var t = ev.target && ev.target.closest ? ev.target.closest('summary, [data-rk-acordeon]') : null;
      if (!t) { return; }
      evento('rk_acordeon_abierto');
      var txt = (t.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt) { marca('rk_acordeon', txt.slice(0, 40)); }
    }, true);

    /* --- 3.4 DESDE DONDE COMPRO ---
       La barra fija de movil y el boton de arriba llevan al mismo sitio.
       Saber cual se usa es lo que dice si la barra sirvió: es la unica
       forma de justificar o descartar ese cambio con datos. */
    var origenFijado = false;
    document.addEventListener('click', function (ev) {
      if (!ev.target || !ev.target.closest) { return; }
      /* GANA EL PRIMERO, Y NO ES UN DETALLE.
         La barra, despues de marcar el pack, pulsa el boton real de la
         ficha. Ese click vuelve a entrar por aqui, asi que sin este candado
         TODA compra hecha desde la barra terminaba registrada como "ficha"
         y el dato que justifica la barra diria siempre lo contrario de lo
         que pasó. */
      if (origenFijado) { return; }
      if (ev.target.closest('.rk-barra__b')) {
        origenFijado = true;
        marca('rk_compra_desde', 'barra_movil');
        evento('rk_barra_usada');
      } else if (ev.target.closest('[data-rk-packs-cta]')) {
        origenFijado = true;
        marca('rk_compra_desde', 'ficha');
      }
    }, true);

    /* --- 3.5 SE FUE SIN COMPRAR ---
       Cierra el embudo: de los que apretaron comprar, cuantos se fueron sin
       llegar al pago. Clarity no puede grabar el checkout de Shopify (va en
       su propio dominio con sandbox), asi que esta es la ultima señal
       nuestra antes de perderlos de vista. */
    window.addEventListener('pagehide', function () {
      if (!yaSalio.rk_pago_pulsado) { cl('event', 'rk_se_fue_sin_intentar'); }
    });
  }
})();
